import * as React from 'react';
import { useSelector } from 'react-redux';

import { SalesLinks } from '../../components/SalesLinks';
import { getSalesLinks } from '../../selectors/getSalesLinks';
import { ESalesType } from '../../types/offersData';
import { trackSalesLinkClick } from './tracking';
import { selectTotal } from '../../selectors/offersData';

export function SalesLinksContainer() {
  const salesLinks = useSelector(getSalesLinks);
  const hasOffers = Boolean(useSelector(selectTotal));

  const handleLinkClick = React.useCallback((type: ESalesType) => {
    trackSalesLinkClick(type);
  }, []);

  if (!salesLinks.length || !hasOffers) {
    return null;
  }

  return <SalesLinks links={salesLinks} onLinkClick={handleLinkClick} />;
}
